// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface PauseIconSignature {
  Element: SVGSVGElement;
}

export const PauseIcon: TOC<PauseIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M7 3H9C10.103 3 11 3.896 11 5V19C11 20.103 10.103 21 9 21H7C5.897 21 5 20.103 5 19V5C5 3.896 5.897 3 7 3ZM7 5V19H9.001L9 5H7ZM17 3H15C13.897 3 13 3.896 13 5V19C13 20.103 13.897 21 15 21H17C18.103 21 19 20.103 19 19V5C19 3.896 18.103 3 17 3ZM15 5V19H17.001L17 5H15Z"/>
</svg>
</template>;